module.exports = __webpack_public_path__ + "img/kommune-233.5240721b.svg";